var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function createColor(color) {
    return __assign(__assign({}, color), { main: color[500], dark: color[700], light: color[200] });
}
export var palette = {
    primary: createColor({
        50: "hsl(240, 0%, 100%)",
        100: "hsl(240, 100%, 95%)",
        200: "hsl(240, 100%, 90%)",
        300: "hsl(240, 90%, 74%)",
        400: "hsl(240, 65%, 64%)",
        500: "hsl(240, 50%, 54%)",
        600: "hsl(240, 45%, 44%)",
        700: "hsl(240, 45%, 34%)",
        800: "hsl(240, 40%, 24%)",
        900: "hsl(240, 35%, 14%)",
    }),
    secondary: createColor({
        50: "hsl(0, 0%, 100%)",
        100: "hsl(300, 100%, 94%)",
        200: "hsl(300, 100%, 87%)",
        300: "hsl(305, 84%, 76%)",
        400: "hsl(305, 84%, 63%)",
        500: "hsl(305, 84%, 53%)",
        600: "hsl(305, 84%, 43%)",
        700: "hsl(305, 83%, 33%)",
        800: "hsl(305, 85%, 23%)",
        900: "hsl(305, 83%, 14%)",
    }),
    grey: createColor({
        50: "hsl(220, 20%, 97%)",
        100: "hsl(210, 15%, 95%)",
        200: "hsl(219, 14%, 89%)",
        300: "hsl(220, 14%, 80%)",
        400: "hsl(217, 15%, 70%)",
        500: "hsl(218, 14%, 50%)",
        600: "hsl(217, 17%, 40%)",
        700: "hsl(216, 16%, 30%)",
        800: "hsl(216, 16%, 20%)",
        900: "hsl(222, 14%, 9%)",
    }),
    success: createColor({
        50: "hsl(136, 0%, 100%)",
        100: "hsl(118, 51%, 92%)",
        200: "hsl(108, 71%, 87%)",
        300: "hsl(136, 70%, 67%)",
        400: "hsl(135, 64%, 57%)",
        500: "hsl(136, 54%, 47%)",
        600: "hsl(136, 65%, 32%)",
        700: "hsl(136, 75%, 23%)",
        800: "hsl(136, 75%, 17%)",
        900: "hsl(136, 75%, 14%)",
    }),
    error: createColor({
        50: "hsl(0, 0%, 100%)",
        100: "hsl(0, 87%, 94%)",
        200: "hsl(0, 90%, 86%)",
        300: "hsl(0, 96%, 76%)",
        400: "hsl(0, 89%, 62%)",
        500: "hsl(0, 89%, 48%)",
        600: "hsl(0, 89%, 42%)",
        700: "hsl(0, 89%, 32%)",
        800: "hsl(0, 89%, 22%)",
        900: "hsl(0, 89%, 14%)",
    }),
    warning: createColor({
        50: "hsl(0, 0%, 100%)",
        100: "hsl(40, 100%, 88%)",
        200: "hsl(40, 100%, 76%)",
        300: "hsl(40, 100%, 70%)",
        400: "hsl(40, 100%, 62%)",
        500: "hsl(40, 100%, 52%)",
        600: "hsl(40, 100%, 42%)",
        700: "hsl(40, 100%, 28%)",
        800: "hsl(40, 100%, 24%)",
        900: "hsl(40, 100%, 14%)",
    }),
    info: createColor({
        50: "hsl(0, 0%, 100%)",
        100: "hsl(207, 100%, 95%)",
        200: "hsl(209, 100%, 85%)",
        300: "hsl(208, 100%, 70%)",
        400: "hsl(208, 100%, 60%)",
        500: "hsl(208, 70%, 50%)",
        600: "hsl(208, 70%, 38%)",
        700: "hsl(208, 70%, 28%)",
        800: "hsl(208, 70%, 18%)",
        900: "hsl(208, 70%, 10%)",
    }),
    black: { main: "hsl(180,4.3%,4.5%)", dark: "hsl(0,0%,0%)" },
    white: { main: "hsl(0,0%,100%)" },
};
